export var ONBOARDING_LINK = 'd/gsn-2hb-3tz/fisherman-onboarding-call';
export var ALL_INCLUDED_ONBOARDING_LINK = 'd/2cn-khm-gnj/fisherman-all-included-onboarding-call';
export var STORYBOOK_TESTING_LINK = 'embed-demo-customer-success/tips-and-tricks-webinar';